import React from 'react';
import CareersHero from '../components/sections/CareersHero';
import JobListings from '../components/sections/JobListings';
import CareersPerks from '../components/sections/CareersPerks';
import Banner4 from '../components/sections/Banner4';

const Careers = () => {
  return (
    <main className="bg-black min-h-screen">
      <CareersHero />
      <JobListings />
      <Banner4 />
    </main>
  );
};

export default Careers;
